export enum HttpErrorCodes {
    AccountNotFoundException = 4001,
    UserNotFoundException = 4002,
    WalletNotFoundException = 4003,
    MerchantNotFoundException = 4004,
    CurrencyNotFoundException = 4005,
    DepositRequestNotFoundException = 4006,
    FiatRateNotFoundException = 4007,
    EmailExistException = 4101,
    NameExistException = 4102,
    PhoneExistException = 4103,
    PasswordMismatchException = 4201,
    SecretCodeMismatchException = 4202,
    NotEnoughMoneyException = 4301,
    NotSuitableCurrencyException = 4302,
    InvalidAmountException = 4303,
    MerchantCurrencyBlockedException = 4304,
    RequestLimitReachedException = 4305,
    IllegalOperationTypeException = 4306,
    AuthorizationException = 4401,
    VerificationException = 4402,
    ValidationException = 4403,
    AccessDeniedException = 4404,
    KycVerificationException = 4405,
    ExchangePairError = 5001,
    LimitExceeded = 5005,
    ErrorFiveTry = 5006,
    // 2FA challenge on critical actions (paired with HTTP 428 / 422 / 429 respectively).
    TwoFactorRequired = 37,
    TwoFactorInvalidCode = 38,
    TwoFactorTooManyAttempts = 39,
    // AML-1005 — deposit replay (POST api/admin/deposits/{entityUuid}/replay).
    DepositAlreadyIngested = 49,      // 409 — already credited (earlier replay or the node's callback)
    DepositTxNotFound = 50,           // 422 — no such transaction on TRON
    DepositAddressMismatch = 51,      // 422 — paid somewhere else; `message` names the address
    DepositNotUsdtTransfer = 52,      // 422 — e.g. a native TRX transfer
    DepositExplorerUnavailable = 53,  // 502 — nothing written, safe to retry
    // AML-1096/1098 — provider kill switch, both paired with HTTP 409.
    ProviderNamedWhileDisabled = 55,
    ProviderStateUnchanged = 56,
    // Paired with HTTP 401 and a null message: the session belongs to an admin that has been
    // deactivated. A plain invalid or expired token returns 401 with an empty body. (AML-1058)
    AdminDeactivated = 33,
    DepositAddressUnavailable = 86, // 503 — AML node unreachable (ADR 0047)
}

// HTTP statuses used by the 2FA challenge–response flow on critical actions.
export const TWO_FACTOR_HTTP = {
    REQUIRED: 428,
    INVALID: 422,
    TOO_MANY: 429,
} as const;
